import { useLocation, useNavigate } from 'react-router-dom'
import {
  LayoutDashboard, Bot, MessageSquareText, BookOpen, Settings,
  PlayCircle, BarChart3, ShoppingCart, Megaphone, Image, HelpCircle,
  ChevronLeft, ChevronRight, Video, AlertTriangle, Users, Database,
  Factory, Sparkles
} from 'lucide-react'
import { useApp } from '../context/AppContext'

const navItems = [
  { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { path: '/agents', icon: Bot, label: 'Agent 工作流中心' },
  { path: '/prompts', icon: MessageSquareText, label: 'Prompt 版本' },
  { path: '/knowledge', icon: BookOpen, label: '知识库 / 规则库' },
  { path: '/models', icon: Settings, label: 'API 网关' },
  { path: '/tasks', icon: PlayCircle, label: '任务执行台' },
  { path: '/reviews', icon: BarChart3, label: '结果复盘库' },
]

const workbenchItems = [
  { path: '/workbench/listing', icon: ShoppingCart, label: 'Listing 优化台' },
  { path: '/workbench/ads', icon: Megaphone, label: '广告诊断台' },
  { path: '/workbench/visual', icon: Image, label: '视觉 Prompt 台' },
  { path: '/workbench/qa', icon: HelpCircle, label: 'QA / Rufus 台' },
]

const futureItems = [
  { path: '/future/video', icon: Video, label: '视频工作台' },
  { path: '/future/review', icon: AlertTriangle, label: '差评处理台' },
  { path: '/future/appeal', icon: Users, label: '申诉工作台' },
  { path: '/future/creator', icon: Sparkles, label: 'Creator 工作台' },
  { path: '/future/supplier', icon: Factory, label: '供应商深挖台' },
  { path: '/future/data', icon: Database, label: '数据助手台' },
]

export default function Sidebar() {
  const location = useLocation()
  const navigate = useNavigate()
  const { sidebarCollapsed, setSidebarCollapsed, currentUser } = useApp()

  return (
    <aside className={`bg-dark-900 text-white flex flex-col transition-all duration-300 ${sidebarCollapsed ? 'w-16' : 'w-64'}`}>
      <div className="h-14 flex items-center justify-between px-4 border-b border-white/10">
        {!sidebarCollapsed && (
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
              <Bot size={18} />
            </div>
            <span className="font-bold text-sm">迁移中台</span>
          </div>
        )}
        <button onClick={() => setSidebarCollapsed(!sidebarCollapsed)} className="p-1 hover:bg-white/10 rounded">
          {sidebarCollapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
        </button>
      </div>

      <div className="flex-1 overflow-y-auto py-4 px-2 space-y-1">
        {navItems.map(item => (
          <div key={item.path} onClick={() => navigate(item.path)}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            title={sidebarCollapsed ? item.label : ''}>
            <item.icon size={18} />
            {!sidebarCollapsed && <span className="text-sm">{item.label}</span>}
          </div>
        ))}

        {!sidebarCollapsed && <div className="px-4 py-2 text-xs text-slate-500 uppercase tracking-wider mt-4">核心工作台</div>}
        {sidebarCollapsed && <div className="border-t border-white/10 my-2" />}

        {workbenchItems.map(item => (
          <div key={item.path} onClick={() => navigate(item.path)}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            title={sidebarCollapsed ? item.label : ''}>
            <item.icon size={18} />
            {!sidebarCollapsed && <span className="text-sm">{item.label}</span>}
          </div>
        ))}

        {!sidebarCollapsed && <div className="px-4 py-2 text-xs text-slate-600 uppercase tracking-wider mt-4">后续扩展</div>}
        {sidebarCollapsed && <div className="border-t border-white/10 my-2" />}

        {futureItems.map(item => (
          <div key={item.path} onClick={() => {}}
            className="nav-item opacity-40 cursor-not-allowed"
            title={sidebarCollapsed ? item.label : ''}>
            <item.icon size={18} />
            {!sidebarCollapsed && <span className="text-sm">{item.label}</span>}
          </div>
        ))}
      </div>

      <div className="p-3 border-t border-white/10">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center text-sm font-bold">
            {currentUser?.avatar || 'U'}
          </div>
          {!sidebarCollapsed && (
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium truncate">{currentUser?.name}</div>
              <div className="text-xs text-slate-400">{currentUser?.role}</div>
            </div>
          )}
        </div>
        {!sidebarCollapsed && (
          <div className="mt-2 text-[10px] text-slate-500 text-center">
            Creator: Leo Young
          </div>
        )}
      </div>
    </aside>
  )
}
